{
  "login": {
    "title": "Sign in",
    "subtitle": "Welcome back",
    "username": "Username",
    "password": "Password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "error": "Login failed"
  },
  "profile": "Profile",
  "logout": "Sign out"
}
